import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/jetbrains-mono/400.css';
import './index.css';
import './styles/tokens.css';

// Browser extensions (e.g. MetaMask) inject scripts that throw on pages they don't serve;
// keep those errors out of the dev error overlay. Capture-phase listeners run first.
const fromExtension = (stack?: string, file?: string) =>
  /(chrome|moz|safari-web)-extension:\/\//.test(`${file ?? ''} ${stack ?? ''}`);
window.addEventListener(
  'error',
  e => {
    if (fromExtension(e.error?.stack, e.filename)) e.stopImmediatePropagation();
  },
  true
);
window.addEventListener(
  'unhandledrejection',
  e => {
    const r: any = e.reason;
    if (fromExtension(r?.stack, '') || /MetaMask/i.test(String(r?.message ?? r)))
      e.stopImmediatePropagation();
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);
